import { Box, styled } from '@mui/material';

export const Section = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  alignSelf: 'stretch',
  width: '100%',
  padding: '8px 0',
}));

export const Divider = styled(Box)(() => ({
  display: 'flex',
  height: '1px',
  padding: '0 16px',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  alignSelf: 'stretch',
  borderRadius: '9999px',
  background: '#C2C3CE',
  width: '100%',
}));

export const Label = styled('span')(() => ({
  color: '#A4A4B6',
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
}));
